import React from 'react';
import './Footer.css';
import imgNuestraSede from '../../../assets/img/imagenes-espacios/nuestrasede.jpg';

const Footer = () => {
  return (
    <footer>
      <div className='dividirColugnas'>
        
        {/* Contenedor e Imagen de la Sede */}
        <div className='contenedorImgSede'>
          <img 
            src={imgNuestraSede} 
            alt="Nuestra Sede Cruz Roja Sucre" 
            className="imgInstituto" 
          />
        </div>

        <div>
          <h2>Contacto</h2>
          <p>Calle 38 No. 29 - 18, Carretera Troncal</p>
          <p>Teléfono: <a href="tel:+573127431631" style={{color: '#fff'}}>(+57 312 743 1631)</a></p>
          <p>Email: <a href="mailto:coordinadoracadémico.sucre@cruzrojacolombiana.org" style={{color: '#fff'}}>coordinadoracadémico.sucre@cruzrojacolombiana.org</a></p>
        </div>

        <div>
          <h2>Horario De Atención</h2>
          <p>Lunes a Viernes: 8:00 AM - 5:00 PM</p>
          <p>Sábados: 9:00 AM - 4:00 PM</p>
          <p>Domingos y Festivos: Cerrado</p>
        </div>
      </div>

      <div className='politicasprivacidad'>
        <p>POLÍTICAS DE PRIVACIDAD</p>
        <p>Reglamento Institucional Instituto de Educación - Cruz Roja Colombiana Seccional Sucre | Manual Interno de Políticas y Procedimientos</p>
        <p>TÉRMINOS Y CONDICIONES-LEGALES</p>
      </div>
    </footer>
  );
};

export default Footer;
